<template>
  <div class="copyright"
       v-html="copyrightInformation"
       style="width: 100%; display: inline-block; line-height: 23px; text-align: center; color: #999999; white-space: pre-wrap;">
  </div>
</template>

<script>
export default {
  name: "copyright",
  data() {
    return {
      copyrightInformation: ''
    }
  },
  mounted() {
    this.copyrightInformation = localStorage.getItem('copyright')
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/client/copyright.vue